module.exports = __webpack_public_path__ + "img/news.6159b393.png";